export const ENTITY_RELATION_LABEL = "Object Relation";

export const ENTITY_RELATION_PLURAL_LABEL = "Object Relations";